const EmailDispositionEnum = Object.freeze({
    SENT: 'SENT',
    DELIVERED: 'DELIVERED',
    REJECTED: 'REJECTED',
    BOUNCED: 'BOUNCED',
    COMPLAINED: 'COMPLAINED',
    OPENED: 'OPENED'
});

export default EmailDispositionEnum;
